// adminApi.js
import axios from 'axios';

const ADMIN_API_SERVICE = `${process.env.REACT_APP_API_URL}/adminservice/api/userCreditsList`;

const apiClient = axios.create({
    baseURL: ADMIN_API_SERVICE,
    withCredentials: true,
});
const adminUserCreditApi = {

    getUserCreditList: (page,pageSize,sortedColumn,sortOrder) =>
        apiClient.get("/allUsersCredits", { params: { page, pageSize, sortedColumn, sortOrder } }),

    getUserCreditsByEmail: (email) =>
        apiClient.get(`/userCredits`, { params: { email } }),
    // New method to fetch frymes (balance, used, free credits)
    getUserCredits: (email) =>
        apiClient.get(`/get-credits?email=${email}`),

    requestUserCredits: (message) =>
        apiClient.post("/request-credits", message),

    addCredits: (userEmail, creditsToAssign) =>
        apiClient.put("/assign-credits", { userEmail, creditsToAssign }),

    updateUserCredits: (updateData) =>
        apiClient.put(`/update`, updateData),

    saveCreditTransaction: (transactionData) =>
        apiClient.post("/creditTransactions", transactionData),


    getCreditTransactionsByUser: (userEmail) =>
        apiClient.get("/getCredtTransactionsByUser", {
            params: { userEmail }
        }),

    getUnseenRequests: () => apiClient.get("/unseen-requests"),

    markAsSeen: (id) => apiClient.put(`/mark-seen/${id}`),

    getCreditLedgerByUserEmail: (userEmail,page,pageSize,sortedColumn,sortOrder) =>
        apiClient.get("/getCreditLedgerByUserEmail", {
            params: { userEmail, page, pageSize, sortedColumn, sortOrder }
        }),


};

export default adminUserCreditApi;
